<template>
    <div class="brief-confirmation-container">
        <title-bar class="margin-bottom-huge" :title="brandName" />
        <div class="brief-confirmation-block">
            <g-level class="margin-bottom-large">
                <g-level-item slot="center">
                    <g-typography tag="h1" font-weight="semibold" :value="pageTitle" />
                </g-level-item>
            </g-level>
            <g-level class="margin-bottom-large">
                <g-level-item slot="center">
                    <g-typography class="break-new-line" tag="p" text-align="center" :value="pageDescription" />
                </g-level-item>
            </g-level>
            <g-level>
                <g-level-item slot="center">
                    <g-button
                        class="dashboard-button"
                        type="primary"
                        shape="round"
                        theme="live"
                        size="large"
                        @click="handleContinue">
                        Continue
                    </g-button>
                </g-level-item>
            </g-level>
        </div>
        <div class="footer-block">
            <powered-by-grin :clickable="true" />
        </div>
    </div>
</template>

<script>
    import TitleBar from '../../../library/TitleBar';
    import {get} from 'lodash';
    import {getCustomizableTitle, getCustomizableText} from '../../../../helpers/activations/default-texts';
    import ActivationBriefMixin from '../../../providers/mixins/ActivationBriefMixin';

    export default {
        name:       'SubmissionConfirmation',
        components: {
            TitleBar,
        },
        mixins: [
            ActivationBriefMixin,
        ],
        props: {
            contact: {
                type:     Object,
                required: true,
            },
        },
        computed: {
            brandName() {
                return get(this.brief, 'brand.name', '');
            },
            pageTitle() {
                return getCustomizableTitle(this.brief, 'submitted_title');
            },
            pageDescription() {
                return getCustomizableText(this.brief, 'submitted_message');
            },
        },
        methods: {
            handleContinue() { // TODO extract this logic for prompting account verification based on activation properties
                if (this.needsVerification()) {
                    this.$router.push({name: 'v2.account.verify'});
                    return;
                }
                window.location.href =  `/${this.contact.live_url}`;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .margin-bottom-large {
        margin-bottom: $g-spacing-6;
    }

    .margin-bottom-huge {
        margin-bottom: $g-spacing-9;
    }

    .brief-confirmation-block {
        text-align: center;
        margin-top: 8em;
        margin-bottom: $g-spacing-8;
    }

    .brief-confirmation-container {
        margin-top: $g-spacing-6;

        & .footer-block {
            padding: $g-spacing-6;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            text-align: center;
        }
    }

    .break-new-line {
        white-space: pre-line;
    }
</style>
